module.exports = [
	{
		"age": "16",
		"thirtyDay": "79.72",
		"sixtyDay": "44.61",
		"ninetyDay": "30.8"
	},
	{
		"age": "17",
		"thirtyDay": "80.11",
		"sixtyDay": "45.11",
		"ninetyDay": "31.3"
	},
	{
		"age": "18",
		"thirtyDay": "80.5",
		"sixtyDay": "45.53",
		"ninetyDay": "31.82"
	},
	{
		"age": "19",
		"thirtyDay": "82.21",
		"sixtyDay": "46.63",
		"ninetyDay": "32.73"
	},
	{
		"age": "20",
		"thirtyDay": "84.67",
		"sixtyDay": "48.36",
		"ninetyDay": "34.15"
	},
	{
		"age": "21",
		"thirtyDay": "87.3",
		"sixtyDay": "50.09",
		"ninetyDay": "35.58"
	},
	{
		"age": "22",
		"thirtyDay": "90.57",
		"sixtyDay": "52.12",
		"ninetyDay": "37.2"
	},
	{
		"age": "23",
		"thirtyDay": "95.28",
		"sixtyDay": "55.06",
		"ninetyDay": "39.52"
	},
	{
		"age": "24",
		"thirtyDay": "99.88",
		"sixtyDay": "58.02",
		"ninetyDay": "41.87"
	},
	{
		"age": "25",
		"thirtyDay": "105.1",
		"sixtyDay": "61.28",
		"ninetyDay": "44.5"
	},
	{
		"age": "26",
		"thirtyDay": "110.35",
		"sixtyDay": "64.61",
		"ninetyDay": "47.15"
	},
	{
		"age": "27",
		"thirtyDay": "115.57",
		"sixtyDay": "67.97",
		"ninetyDay": "49.89"
	},
	{
		"age": "28",
		"thirtyDay": "121.6",
		"sixtyDay": "71.84",
		"ninetyDay": "53.04"
	},
	{
		"age": "29",
		"thirtyDay": "127.33",
		"sixtyDay": "75.59",
		"ninetyDay": "56.09"
	},
	{
		"age": "30",
		"thirtyDay": "133.5",
		"sixtyDay": "79.54",
		"ninetyDay": "59.24"
	},
	{
		"age": "31",
		"thirtyDay": "143.44",
		"sixtyDay": "85.74",
		"ninetyDay": "64.22"
	},
	{
		"age": "32",
		"thirtyDay": "153.52",
		"sixtyDay": "92.14",
		"ninetyDay": "69.19"
	},
	{
		"age": "33",
		"thirtyDay": "164.5",
		"sixtyDay": "99.04",
		"ninetyDay": "74.67"
	},
	{
		"age": "34",
		"thirtyDay": "176.16",
		"sixtyDay": "106.27",
		"ninetyDay": "80.46"
	},
	{
		"age": "35",
		"thirtyDay": "188.05",
		"sixtyDay": "113.78",
		"ninetyDay": "86.35"
	},
	{
		"age": "36",
		"thirtyDay": "199.31",
		"sixtyDay": "120.77",
		"ninetyDay": "91.94"
	},
	{
		"age": "37",
		"thirtyDay": "210.96",
		"sixtyDay": "128.11",
		"ninetyDay": "97.63"
	},
	{
		"age": "38",
		"thirtyDay": "222.87",
		"sixtyDay": "135.41",
		"ninetyDay": "103.42"
	},
	{
		"age": "39",
		"thirtyDay": "234.76",
		"sixtyDay": "142.82",
		"ninetyDay": "109.31"
	},
	{
		"age": "40",
		"thirtyDay": "246.68",
		"sixtyDay": "150.13",
		"ninetyDay": "115"
	},
	{
		"age": "41",
		"thirtyDay": "258.71",
		"sixtyDay": "157.55",
		"ninetyDay": "120.69"
	},
	{
		"age": "42",
		"thirtyDay": "271.15",
		"sixtyDay": "165.07",
		"ninetyDay": "126.56"
	},
	{
		"age": "43",
		"thirtyDay": "283.33",
		"sixtyDay": "172.49",
		"ninetyDay": "132.26"
	},
	{
		"age": "44",
		"thirtyDay": "295.36",
		"sixtyDay": "179.79",
		"ninetyDay": "137.84"
	},
	{
		"age": "45",
		"thirtyDay": "307.4",
		"sixtyDay": "187",
		"ninetyDay": "143.43"
	},
	{
		"age": "46",
		"thirtyDay": "321.27",
		"sixtyDay": "195.32",
		"ninetyDay": "149.73"
	},
	{
		"age": "47",
		"thirtyDay": "335.26",
		"sixtyDay": "203.76",
		"ninetyDay": "156.23"
	},
	{
		"age": "48",
		"thirtyDay": "349.78",
		"sixtyDay": "212.39",
		"ninetyDay": "162.72"
	},
	{
		"age": "49",
		"thirtyDay": "364.19",
		"sixtyDay": "221.02",
		"ninetyDay": "169.33"
	},
	{
		"age": "50",
		"thirtyDay": "379.37",
		"sixtyDay": "230.27",
		"ninetyDay": "176.35"
	},
	{
		"age": "51",
		"thirtyDay": "397.41",
		"sixtyDay": "241.14",
		"ninetyDay": "184.66"
	},
	{
		"age": "52",
		"thirtyDay": "415.61",
		"sixtyDay": "252.2",
		"ninetyDay": "193.29"
	},
	{
		"age": "53",
		"thirtyDay": "435.76",
		"sixtyDay": "264.5",
		"ninetyDay": "202.84"
	},
	{
		"age": "54",
		"thirtyDay": "456.84",
		"sixtyDay": "277.6",
		"ninetyDay": "213.1"
	},
	{
		"age": "55",
		"thirtyDay": "479.73",
		"sixtyDay": "291.93",
		"ninetyDay": "224.49"
	},
	{
		"age": "56",
		"thirtyDay": "504.59",
		"sixtyDay": "307.67",
		"ninetyDay": "237.17"
	},
	{
		"age": "57",
		"thirtyDay": "531.56",
		"sixtyDay": "325.03",
		"ninetyDay": "251.29"
	},
	{
		"age": "58",
		"thirtyDay": "561.25",
		"sixtyDay": "344.43",
		"ninetyDay": "267.33"
	},
	{
		"age": "59",
		"thirtyDay": "594.49",
		"sixtyDay": "366.48",
		"ninetyDay": "285.83"
	},
	{
		"age": "60",
		"thirtyDay": "587.3",
		"sixtyDay": "358.96",
		"ninetyDay": "276.88"
	},
	{
		"age": "61",
		"thirtyDay": "535.47",
		"sixtyDay": "326.55",
		"ninetyDay": "250.57"
	},
	{
		"age": "62",
		"thirtyDay": "495.57",
		"sixtyDay": "300.55",
		"ninetyDay": "228.14"
	},
	{
		"age": "63",
		"thirtyDay": "456.44",
		"sixtyDay": "271.49",
		"ninetyDay": "199.29"
	},
	{
		"age": "64",
		"thirtyDay": "322.84",
		"sixtyDay": "173.49",
		"ninetyDay": "104.84"
	}
];


//////////////////
// WEBPACK FOOTER
// C:/Git/qsuper-fed/~/json-loader!./src/data/standardRateUnitisedFiveYear.json
// module id = 454
// module chunks = 0